// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
// Components, Layouts, Pages
import AvailableLesson from './component/availableLesson/AvailableLesson';
import ScheduledLesson from './component/scheduledLesson/ScheduledLesson';
// Others
import { useAppDispatch } from '~/utils/redux/hooks';
import { getCourseUpcoming } from '~/thunks/course/courseThunk';
// Styles, images, icons
import styles from './Course.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Course = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/home', 'common/base', 'common/course']);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    handleGetListCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion Implement Hook

  //#region Handle Function

  const handleGetListCourses = async () => {
    await dispatch(getCourseUpcoming()).unwrap();
  };
  //#endregion Handle Function

  return (
    <div className={cx('container')}>
      <div className={cx('contentContainer')}>
        <AvailableLesson />
      </div>
      <div className={cx('scheduledContainer')}>
        <ScheduledLesson />
      </div>
    </div>
  );
};

export default Course;
